<template>
  <div class="sectionBox4">
    <div class="topBox">
      <van-nav-bar title="支付教程" left-arrow @click-left="onClickLeft" />
    </div>
    <div class="cardBox">
      <div class="cardItem">
        <p>第一步：点击微信右上角加号，点击扫一扫</p>
        <el-image :src="require('../../assets/shopping/course1.png')"></el-image>
        <p>第二步：点击相册选择：保存的二维码或者截图</p>
        <el-image :src="require('../../assets/shopping/course2.png')"></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    // 返回
    onClickLeft() {
      history.back();
    },
  },
};
</script>

<style lang="scss">
.sectionBox4 {
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .topBox {
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 10;
    height: 46px;
  }
  .cardBox {
    position: relative;
    top: 46px;
    background-color: #f5f5f5 !important;
    height: calc(100% - 46px);
    z-index: 1;
    overflow: auto;
    .cardItem {
      margin: 10px 20px;
      p{
        color: #ff0000;
        font-size: 16px;
      }
    }
  }
}
</style>
